import React from 'react';

const PageHeader = ({ title, description, highlight, parent }) => {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-24 overflow-hidden">
         {/* Background Image - Fixed Everest Cover */}
         <div 
            className="absolute inset-0 bg-cover bg-no-repeat"
            style={{ 
                backgroundImage: "url('https://customer-assets.emergentagent.com/job_everestcloud/artifacts/spue5mbw_backgroundjpeg.jpg')",
                backgroundPosition: "center 30%",
            }}
        ></div>
        
        {/* Clean Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/80 to-white dark:from-slate-950/60 dark:via-slate-950/80 dark:to-slate-950 transition-colors duration-500"></div>

        <div className="container relative z-10 mx-auto px-4 flex flex-col items-center text-center">
            
            {parent && (
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent/10 border border-accent/20 mb-6 animate-in fade-in slide-in-from-top-2 duration-700">
                    <span className="text-xs font-bold text-accent tracking-[0.15em] uppercase">{parent}</span>
                </div>
            )}
            
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 tracking-tight text-slate-900 dark:text-white leading-[1.1] animate-in fade-in zoom-in-95 duration-700">
                {title} {highlight && <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-yellow-600 dark:from-accent dark:to-yellow-500">{highlight}</span>}
            </h1>
            
            <p className="text-lg md:text-xl text-slate-600 dark:text-slate-300 max-w-3xl font-normal leading-relaxed animate-in fade-in slide-in-from-bottom-2 duration-700 delay-100">
                {description}
            </p>
        </div>
    </section>
  );
};

export default PageHeader;
